import React, { useEffect, useRef, useState } from 'react'
import { hexToRgb } from '../../../utils/colorUtils'
import useRefDimensions from '../../../hooks/useRefDimensions'

interface SvgColorChangerProps {
  svgUrl: string // L'URL de l'image SVG
  fillColor?: string // La couleur finale souhaitée
  height?: string // La hauteur de l'image
}

const SvgColorChanger = ({
  svgUrl,
  fillColor,
  height
}: SvgColorChangerProps) => {
  const [filter, setFilter] = useState<JSX.Element>()
  const [hex, setHex] = useState<string>()
  const [ratio, setRatio] = useState<number>(1)
  const divRef = useRef<HTMLDivElement>(null)
  const svgRef = useRef<SVGSVGElement>(null)
  const dimensions = useRefDimensions(divRef)

  const rgbToCssFilter = (r: number, g: number, b: number): JSX.Element => {
    const hex = `${(r & 0xff).toString(16).padStart(2, '0')}${(g & 0xff)
      .toString(16)
      .padStart(2, '0')}${(b & 0xff).toString(16).padStart(2, '0')}`

    setHex(hex)

    return (
      <filter id={hex} colorInterpolationFilters='sRGB'>
        <feColorMatrix
          type='matrix'
          values={`0 0 0 0 ${r / 255.0} 0 0 0 0 ${g / 255.0} 0 0 0 0 ${
            b / 255.0
          } 0 0 0 1 0`}
        />
      </filter>
    )
  }

  useEffect(() => {
    if (fillColor) {
      const rgbColor = hexToRgb(fillColor)
      setFilter(rgbToCssFilter(rgbColor.r, rgbColor.g, rgbColor.b))
    }
  }, [fillColor])

  const handleLoaded = (): void => {
    if (svgRef.current) {
      const box = svgRef.current.getBBox()
      setRatio(box.width / box.height)
    }
  }

  return (
    <div ref={divRef} className='rf-h-full' style={{
      width: dimensions.height * ratio
    }}>
      <svg ref={svgRef} className='rf-filter rf-w-full' height={height || '100%'}>
        {filter && <defs>{filter}</defs>}
        <image
          filter={filter ? `url(#${hex})` : undefined}
          onLoad={handleLoaded}
          href={svgUrl}
          x='0'
          y='0'
          height={height || dimensions.height}
        />
      </svg>
    </div>
  )
}

export default SvgColorChanger
